import { Box, Text } from '@chakra-ui/react';

export const CheckboxPreview = () => {
  return (
    <Box>
      <Text>CheckboxPreview - Coming soon</Text>
    </Box>
  );
};
